var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyhole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3217_141034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9279 42.6301C39.9883 42.7817 40.0107 42.9458 39.9931 43.108C39.9755 43.2702 39.9184 43.4256 39.827 43.5608C39.7355 43.6959 39.6124 43.8065 39.4683 43.8831C39.3242 43.9597 39.1636 43.9999 39.0004 44.0001H25.0004C24.8373 43.9999 24.6766 43.9597 24.5326 43.8831C24.3885 43.8065 24.2653 43.6959 24.1739 43.5608C24.0824 43.4256 24.0254 43.2702 24.0078 43.108C23.9902 42.9458 24.0126 42.7817 24.0729 42.6301L27.3229 34.4851C25.952 33.4947 24.9303 32.0953 24.4044 30.4878C23.8786 28.8804 23.8757 27.1477 24.3962 25.5385C24.9167 23.9293 25.9337 22.5265 27.3013 21.5315C28.6689 20.5365 30.3167 20.0005 32.0079 20.0005C33.6992 20.0005 35.3469 20.5365 36.7145 21.5315C38.0821 22.5265 39.0992 23.9293 39.6197 25.5385C40.1401 27.1477 40.1373 28.8804 39.6114 30.4878C39.0856 32.0953 38.0638 33.4947 36.6929 34.4851L39.9279 42.6301Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3217_141034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyhole);
export default __webpack_public_path__ + "static/media/keyhole.c77e606e655831e7f94e9df00dda64af.svg";
export { ForwardRef as ReactComponent };